import { EventEmitter, Injectable } from '@angular/core';
import { IGfxFile } from './IGfxFile';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { GfxStoreService } from '../../services/gfx.store.service';
import { GfxHttpSrv } from "../../services/GfxHttpSrv";
import { SharingDataService } from "../../services/sharing-data.service";
import { GfxUpDownHelper } from "../../services/GfxUpDownHelper";
import { IGfxOpResObj } from "../../models/IGfxOpResObj";
import menuUrls from '../../../environments/urlsBe.json';
import {environment} from '../../../environments/environment';
import {IGfxGedSimpleConfig} from './IGfxGedSimpleConfig';

@Injectable()
export class GfxGedService {
    public gedSimpleNewDocEvent = new EventEmitter<any>();

    configDoc: IGfxGedSimpleConfig;
    backendUrl = environment.BackendUrl;
    constructor(
        private upDownHelper: GfxUpDownHelper,
        private http: GfxHttpSrv,
        private sharing: SharingDataService,
        private store: GfxStoreService
    ) {
    }

    newFile(file: File, params): Observable<number> {
        return this.upDownHelper.upload(file, this.backendUrl + "/" + menuUrls.registerDoc, params);
    }

    // downloadFile(file: IGfxFile): Observable<Blob> {
    //     return this.upDownHelper.download(file.fileUrl);
    // }
    downloadFile(file: IGfxFile): Observable<Blob> {
        return this.upDownHelper.download('core/gfxged/getDoc?id=' + file.id);
    }

    deleteFile(id): Observable<IGfxOpResObj> {

        return this.http.delete(menuUrls.delDoc, id);

    }

    editFile(file: IGfxFile) {

        return this.http.put('core/gfxged/update', file);
    }

    updateFileInfos(infosPiece: InfosPiece) {
        return this.http.post('core/gfxged/infoPiece', infosPiece);
    }

    getFiles(config) {
        this.configDoc = {
            idTbl: config.find(item => item.Name === 'idTbl').Value,
            idElem: config.find(item => item.Name === 'idElem').Value,
            code: config.find(item => item.Name === 'code').Value
        };
        return this.http
            .get(menuUrls.listDocs, this.configDoc);
    }

    imgFileToBase64(file) {
        let params = new HttpParams();
        params = params.set('id', file);

        return this.http.get('core/gfxged/base64img', { id: file });
    }
}

export interface InfosPiece {
    id;
    title;
    desc;
}
